import { computed, makeObservable } from "mobx";
import { buildTeamLogoOptions, getTeamLogoUrlByTeamId } from "@draftkings/sportsbook-common-utils";
export class PlayerPageParser {
    constructor(options) {
        this.dict = options.dict;
        this.retriever = options.retriever;
        this.logError = options.logError;
        this.playerId = "";
        this.swooshBaseUrl = options.productConfig.swooshBaseUrl;
        this.isSwooshTeamLogoEnabledInPlayerPage = options.featureFlags["RLS-OSB-WEB-IsSwooshTeamLogosEnabled"].PlayerPage;
        makeObservable(this, {
            playerBiometricData: computed
        });
    }
    activate() {
        this.retriever.activate();
    }
    deactivate() {
        this.retriever.deactivate();
    }
    loadBiometricData(playerId) {
        this.playerId = playerId;
        return this.retriever
            .loadData(playerId)
            .catch(error => {
            this.logError({
                description: error.message,
                playerId,
                statusCode: "UnknownPlayerBiometricApiError"
            });
            return error;
        });
    }
    setParams(params) {
        const paramsPlayerId = params.playerId.toString();
        if (paramsPlayerId !== this.playerId) {
            this.retriever.clearData();
            void this.loadBiometricData(paramsPlayerId);
        }
    }
    get playerBiometricData() {
        return this.retriever.data.map(d => {
            var _a, _b, _c, _d, _e;
            return ({
                fullName: `${d.firstName} ${d.lastName}`,
                positionName: d.positionName,
                teamName: ((_a = d.team) === null || _a === void 0 ? void 0 : _a.teamName) || "",
                primaryTeamColor: (_b = d.team) === null || _b === void 0 ? void 0 : _b.primaryTeamColor,
                positionPhrase: this.dict.Position,
                teamLogo: this.isSwooshTeamLogoEnabledInPlayerPage ?
                    this.getTeamLogo(d.teamId || ((_c = d.team) === null || _c === void 0 ? void 0 : _c.teamId)) :
                    (_e = (_d = d.team) === null || _d === void 0 ? void 0 : _d.teamLogoUrls) === null || _e === void 0 ? void 0 : _e[160],
            });
        });
    }
    getTeamLogo(teamId) {
        var _a;
        return (_a = getTeamLogoUrlByTeamId(this.swooshBaseUrl, teamId === null || teamId === void 0 ? void 0 : teamId.toString(), buildTeamLogoOptions("lg", "light"))) === null || _a === void 0 ? void 0 : _a.toString();
    }
}
//# sourceMappingURL=PlayerPageParser.js.map